module.exports = __webpack_public_path__ + "img/partner_icon1.915b36d6.png";